import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: false
};

export const sidebarSlice = createSlice({
  name: '@@sidebar',
  initialState,
  reducers: {
    TOGGLE_SIDEBAR: state => {
      state.sidebarOpen = !state.sidebarOpen;
    }
  }
});

export const { TOGGLE_SIDEBAR } = sidebarSlice.actions;
export default sidebarSlice.reducer;
